import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const UnifiedVideoStaticSchema = BaseWidgetSchema(WidgetType.UnifiedVideo).extend({
  title: z.string(),
  src: z.string(),
  srcType: z.string().nullable()
});

export type UnifiedVideoStaticSchemaType = z.infer<typeof UnifiedVideoStaticSchema>;
